module.exports = __webpack_public_path__ + "img/PS16.b009ebbe.png";